"use client";

import styled, { css } from "styled-components";

export const TableBody = styled.div<{
  $minHeight?: string;
  $rowMinHeight: string;
  $fillHeight?: boolean;
}>`
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: var(--Border-Radius-8, 0.8rem);
  border-bottom-right-radius: var(--Border-Radius-8, 0.8rem);

  background: var(--Color-Common-Bg-Interactive-Secondary, #fff);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  border-top: none;

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight};
    `}

  ${({ $rowMinHeight, $fillHeight }) =>
    $fillHeight
      ? css`
          height: 100%;
          min-height: 0;

          > * {
            flex: 1 1 0;
            min-height: 0;
            display: flex;
          }

          .table-row > * {
            height: 100%;
          }

          .shell {
            height: 100%;
          }
        `
      : css`
          .shell {
            height: ${$rowMinHeight};
          }
        `}
`;
